import { CreateLifeglovLinerOrderBody } from '@bioliberty/lifemind';
import { HttpMethod } from '../util/http';
import { tms } from './tms';

const lifeglovLinerOrderApi = tms.injectEndpoints({
  endpoints: (builder) => ({
    createLifeglovLinerOrder: builder.mutation<void, CreateLifeglovLinerOrderBody>({
      query: (body) => ({
        url: `lifeglov-liner-orders`,
        method: HttpMethod.Post,
        body
      }),
      invalidatesTags: ['LifeglovLinerOrder']
    })
  })
});

export const { useCreateLifeglovLinerOrderMutation } = lifeglovLinerOrderApi;
